<app-section-grid [subSection]="'Create Company'"></app-section-grid>

<app-stepper-grid></app-stepper-grid>

<div class="relative w-full max-w-4xl mx-auto p-10 bg-white rounded-3xl border border-gray-200 mb-5">
  <form [formGroup]="companyForm" (ngSubmit)="onSubmit()">

    <!-- Header -->
    <div class="text-center mb-10">
      <h1 class="text-3xl font-bold text-gray-800 tracking-tight">
        Company Details
      </h1>
      <p class="mt-2 text-gray-500">
        Enter/Update the company information below.
      </p>
    </div>

    <!-- Fields -->
    <div class="grid grid-cols-12 gap-6">

      <!-- Name -->
      <div class="col-span-12 lg:col-span-12">
        <label class="block text-sm font-semibold text-gray-700 mb-2">
          🏷️ Name <small class="text-red-300">(required)</small>
        </label>

        <textarea
          formControlName="Name"
          rows="1"
          (keydown.enter)="$event.preventDefault()"
          placeholder="Enter name..."
          class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
        </textarea>

        <div
          *ngIf="companyForm.get('Name')?.touched && companyForm.get('Name')?.hasError('required')"
          class="mt-1 text-xs text-red-500">
          Name is required.
        </div>
      </div>

      <!-- City -->
      <div class="col-span-12 lg:col-span-12">
        <label class="block text-sm font-semibold text-gray-700 mb-2">
          📍 City <small class="text-gray-400">(optional)</small>
        </label>

        <textarea
          formControlName="city"
          rows="1"
          (keydown.enter)="$event.preventDefault()"
          placeholder="Enter city..."
          class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
        </textarea>
      </div>

      <!-- Address -->
      <div class="col-span-12 lg:col-span-12">
        <label class="block text-sm font-semibold text-gray-700 mb-2">
          📍 Address <small class="text-gray-400">(optional)</small>
        </label>

        <textarea
          formControlName="address"
          rows="1"
          (keydown.enter)="$event.preventDefault()"
          placeholder="Enter address..."
          class="w-full resize-none border border-gray-300 rounded-xl px-4 py-2.5 bg-gray-50 text-gray-700
                 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm shadow-sm transition-colors">
        </textarea>
      </div>
    </div>

    <!-- Submit button (replaces app-submit-grid) -->
    <div class="mt-8 flex justify-end">
      <button
        type="submit"
        class="inline-flex items-center px-6 py-2.5 rounded-xl bg-blue-600 text-white text-sm font-semibold
               shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1
               disabled:opacity-50 disabled:cursor-not-allowed"
        [disabled]="companyForm.invalid">
        Save Company
      </button>
    </div>

  </form>
</div>

<app-footer-grid></app-footer-grid>
